import React, { useState } from 'react';
import './ShareButton.css';

interface ShareButtonProps {
  title: string;
  description?: string;
  url: string;
  date?: string;
  location?: string;
  size?: 'small' | 'medium' | 'large';
  showLabel?: boolean;
}

const ShareButton: React.FC<ShareButtonProps> = ({ 
  title, 
  description, 
  url, 
  date,
  location,
  size = 'medium',
  showLabel = true
}) => {
  const [showToast, setShowToast] = useState(false);

  const handleShare = async () => {
    // Build share text
    let shareText = `Check out: ${title}`;
    if (date) shareText += `\n📅 ${date}`;
    if (location) shareText += `\n📍 ${location}`;
    if (description) shareText += `\n\n${description}`;
    shareText += `\n\n🔗 ${url}`;

    // Check if native share is available
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: shareText,
          url: url,
        });
      } catch (error) {
        // User cancelled or error occurred
        if ((error as Error).name !== 'AbortError') {
          console.error('Error sharing:', error);
          fallbackCopyToClipboard(url);
        }
      }
    } else {
      // Fallback: Copy to clipboard
      fallbackCopyToClipboard(url);
    }
  };

  const fallbackCopyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  };

  return (
    <>
      <button 
        className={`share-button ${size}`}
        onClick={handleShare}
        aria-label="Share"
        title="Share"
      >
        <svg 
          className="share-icon" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <circle cx="18" cy="5" r="3"></circle>
          <circle cx="6" cy="12" r="3"></circle>
          <circle cx="18" cy="19" r="3"></circle>
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
          <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
        </svg>
        {showLabel && <span className="share-label">Share</span>}
      </button>

      {showToast && (
        <div className="share-toast">
          ✓ Link copied to clipboard!
        </div>
      )}
    </>
  );
};

export default ShareButton;
